/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantConfig } from '../../models/tenant-config';

export interface AdminTenantGet$Params {
}

export function adminTenantGet(http: HttpClient, rootUrl: string, params?: AdminTenantGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<Array<TenantConfig>>> {
  const rb = new RequestBuilder(rootUrl, adminTenantGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<Array<TenantConfig>>;
    })
  );
}

adminTenantGet.PATH = '/Admin/tenant';
